module.exports = __webpack_public_path__ + "media/images/icons/ic-video-call-1d8413a02e07a9ed6743cdde4ee3df07.svg";